<wlm-leaflet-map
  *ngIf="namespaces"
  (layerClicked)="onSelectedLayerChanged($event)"
  (timeChanged)="onTimeChangedChanged($event)"
  [enableParamsExport]="isEmbedded$ | async"
  [parentWidgetInstanceKey]="parentWidgetInstanceKey"
  [mapDateRange]="mapDateRange"
  [tooltipMetadata]="tooltipMetadata"
  [layersNameSpaces]="namespaces"
  [sidePanelSettings]="sidePanelSettings"
  [topBarConfiguration]="topBarConfiguration"
  [mapId]="widgetInstanceKey"
></wlm-leaflet-map>
